import React from 'react';
import Form from '../../../components/formConfiguration/Form';
import Tip from '../../../ui/Tip';
import {IFormConfiguration} from '../../../models/form/FormConfiguration';
import {SectionConfigurationQL} from '../../../models/graphql/SectionConfigurationQL';
import {FormTypeContext, RegistrationFormContextData} from '../../../components/formConfiguration/types';

type FormProps = {
  sectionConfigurations: SectionConfigurationQL[]
  backLink: string
  onSubmit?: (input: any) => void
  configuration?: IFormConfiguration
}

export default function ConfigurationForm({
  sectionConfigurations, backLink, onSubmit, configuration,
}: FormProps) {
  const tip = () => (
    <Tip className="mb-3">
      If you have questions how to configure registration forms, check out&nbsp;<a
      href="https://support.workshopbutler.com/article/35-how-to-customise-a-registration-form"
      target="_blank" rel="noreferrer" className="font-bold text-yellow -mt-px">this article</a>.
    </Tip>
  );

  return (
    <FormTypeContext.Provider value={RegistrationFormContextData}>

      <Form sectionConfigurations={sectionConfigurations} onSubmit={onSubmit}
        backLink={backLink} tip={tip()} formConfiguration={configuration} excludeV1={false}
        withInstructions={true}/>
    </FormTypeContext.Provider>
  );
}
